import CreateReducer from '@nocode-works/template/store/utils/createReducer'
import CreateActions from '@nocode-works/template/store/utils/createActions'
import networkWrapper from '@nocode-works/template/store/utils/networkWrapper'
import {
  handlers,
} from '@nocode-works/template/store/utils/api'

import snackbarActions from '@nocode-works/template/store/modules/snackbar'
import userSelectors from '../selectors/user'
import {
  LOGOUT_URL,
} from 'settings'

const prefix = 'user'
const wrapper = networkWrapper.factory(prefix)

const initialState = {
  loaded: false,
  data: null,
  accessToken: null,
}

const reducers = {
  setData: (state, action) => {
    state.loaded = true
    state.data = action.payload || null
  },
  setAccessToken: (state, action) => {
    state.accessToken = action.payload
  }
}

const sideEffects = {

  loadStatus: () => wrapper('loadStatus', async (dispatch, getState) => {
    const data = await handlers.get(`/auth/status`)
    dispatch(actions.setData(data))
  }),

  setupTracking: () => (dispatch, getState) => {
    if(!window._nocodeTrackingInitialise) return
    window._nocodeTrackingInitialise()
    if(!window._nocodeTrackingIdentifyUser) return
    const user = userSelectors.data(getState())
    window._nocodeTrackingIdentifyUser(user)
  },

  logout: () => wrapper('logout', async (dispatch, getState) => {
    await handlers.post(`/auth/logout`)
    document.location = LOGOUT_URL
  }),

  generateAccessToken: () => wrapper('generateAccessToken', async (dispatch, getState) => {
    const data = await handlers.put(`/auth/accessToken`)
    dispatch(actions.setAccessToken(data))
  }),

  updateMeta: ({
    data,
    snackbarMessage,
  }) => wrapper('updateMeta', async (dispatch, getState) => {
    await handlers.put(`/auth/update`, data)
    await dispatch(actions.loadStatus())
    if(snackbarMessage) {
      dispatch(snackbarActions.setSuccess(snackbarMessage))
    }
  }),

  createInitialWebsite: ({
    template,
  }) => wrapper('createInitialWebsite', async (dispatch, getState) => {
    const result = await handlers.post(`/websites/initial`, {template})
    if(result.id) {
      document.location = `/builder/website/${result.id}`
    }
  }),
}

const reducer = CreateReducer({
  initialState,
  reducers,
  prefix,
})

const actions = CreateActions({
  reducers,
  sideEffects,
  prefix,
})

export { actions, reducer }
export default actions